(function() {
    'use strict';

    var dialogAlertError = {
        template: '<div class="alert alert-danger fade in" ng-if="$ctrl.alerts && $ctrl.alerts.length > 0">' +
            '<p ng-repeat="alert in $ctrl.alerts">{{ alert.msg }}</p>' +
        '</div>',
        controller: dialogAlertErrorController
    };

    angular
        .module('ccsTrApp')
        .component('dialogAlertError', dialogAlertError);

    dialogAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function dialogAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (httpResponse, message, key, data) {
            if (key === 'ccsTrApp.growth.error.growthexists') {
                key = 'Growth with the same location already exists';
            }
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key + (httpResponse && httpResponse.description ? (" : " + httpResponse.description) : ""),
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('ccsTrApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
                // connection refused, server not reachable
                case 0:
                    addErrorAlert(httpResponse.data, 'Server not reachable','error.server.not.reachable');
                    break;
                case 400:
                    var errorHeader = httpResponse.headers('X-ccsTrApp-error');
                    var entityKey = httpResponse.headers('X-ccsTrApp-params');
                    if (errorHeader) {
                        errorHeader = 'ccsTrApp.' + entityKey + '.' + errorHeader;
                        var entityName = $translate.instant('global.menu.entities.' + entityKey);
                        addErrorAlert(httpResponse.data, errorHeader, errorHeader, {entityName: entityName});
                    } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                        for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                            var fieldError = httpResponse.data.fieldErrors[i];
                            // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                            var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                            var fieldName = $translate.instant('ccsTrApp.' + fieldError.objectName + '.' + convertedField);
                            addErrorAlert(httpResponse.data, 'Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                        }
                    } else if (httpResponse.data && httpResponse.data.message) {
                        addErrorAlert(httpResponse.data, httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                    } else {
                        addErrorAlert(httpResponse.data, httpResponse.data);
                    }
                    break;

                case 404:
                    addErrorAlert(httpResponse.data, 'Not found','error.url.not.found');
                    break;

                case 409:
                    if (httpResponse.config.method === 'DELETE') {
                        if (httpResponse.config.url.indexOf('api/countries/') > -1) {
                            addErrorAlert(undefined, 'Country is used and can not be deleted');
                        } else if (httpResponse.config.url.indexOf('api/companies/') > -1) {
                            addErrorAlert(undefined, 'Company is used and can not be deleted');
                        } else if (httpResponse.config.url.indexOf('api/ports/') > -1) {
                            addErrorAlert(undefined, 'Port is used and can not be deleted');
                        } else if (httpResponse.config.url.indexOf('api/keywords/') > -1) {
                            addErrorAlert(undefined, 'Keyword is used and can not be deleted');
                        }
                    } else {
                        if (httpResponse.data && httpResponse.data.message) {
                            addErrorAlert(httpResponse.data, httpResponse.data.message);
                        } else {
                            addErrorAlert(httpResponse.data, angular.toJson(httpResponse));
                        }
                    }
                    break;

                default:
                    if (httpResponse.data && httpResponse.data.message) {
                        addErrorAlert(httpResponse.data, httpResponse.data.message);
                    } else {
                        addErrorAlert(httpResponse.data, angular.toJson(httpResponse));
                    }
                    break;
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();
